import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

import { useAppSelector } from '../../../../../../app/hooks'
import { postCall } from '../../../../../../features/phone/phoneThunk'
import { CallResponse } from '../../../../../../features/phone/types'
import { useEffect, useState } from 'react'
import { getRandomArrayItem } from '../../../../../../shared/utils'
import {
  ACCEPTED_LOW_CHAR_WORDS,
  DEFAULT_EXCHANGES,
  PHONE_INPUT_ERRORS,
} from '../phone.consts'
import { clearCall } from '../../../../../../features/phone/phoneSlice'

type FormValues = {
  exchange: string
  number: string
  message: string
}

const useTelephone = () => {
  const dispatch = useDispatch()

  const [error, setError] = useState<string | undefined>()

  const {
    data: phoneData,
    loading: phoneLoading,
    error: phoneError,
  } = useAppSelector(
    (state) =>
      state.phone?.call || {
        data: null,
        loading: false,
        error: null,
      }
  )

  const methods = useForm<FormValues>({
    defaultValues: {
      exchange: DEFAULT_EXCHANGES[0],
      number: '',
      message: '',
    },
  })

  // =======================
  // Effects
  // =======================
  useEffect(() => {
    return () => {
      // clear poi on unmount
      dispatch(clearCall())
    }
  }, [dispatch])

  // =======================
  // Handlers
  // =======================

  const onSubmit = (values: FormValues) => {
    const number = `${values.exchange} ${values.number}`
    const message = values.message?.trim()

    setError('')

    const isValidPhoneMessage = (message?: string) => {
      if (!message) return false

      const normalized = message.trim().toLowerCase()
      if (!normalized) return false

      if (normalized.length >= 3) return true

      return ACCEPTED_LOW_CHAR_WORDS.has(normalized)
    }

    if (!isValidPhoneMessage(message)) {
      setError(getRandomArrayItem(PHONE_INPUT_ERRORS))
      return
    }

    dispatch(
      postCall({
        number,
        message: values.message,
      })
    )
  }

  return {
    exchanges: DEFAULT_EXCHANGES,
    register: methods.register,
    CallResponse: phoneData as CallResponse | null,
    loading: phoneLoading,
    error: error || phoneError,
    handlers: {
      handleSubmit: methods.handleSubmit(onSubmit),
    },
  }
}

export default useTelephone
